import { render, staticRenderFns } from "./senSample.vue?vue&type=template&id=02c31804&scoped=true"
import script from "./senSample.vue?vue&type=script&lang=js"
export * from "./senSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c31804",
  null
  
)

export default component.exports